import React from 'react';
import { cn } from '@/lib/utils';

export interface StatusBadgeProps {
  status: string;
  label?: string;
  className?: string;
  showDot?: boolean;
}

export function StatusBadge({ status, label, className, showDot = true }: StatusBadgeProps) {
  const norm = String(status || '').toLowerCase().trim();

  let bgClass = "bg-[#fff7ed] text-[#ea580c] border-[#ffedd5]";
  let dotClass = "bg-[#ea580c] animate-pulse";
  let defaultLabel = "Đang chờ duyệt";

  if (['approved', 'accepted', 'active'].includes(norm)) {
    bgClass = "bg-[#f0fdf4] text-[#16a34a] border-[#dcfce7]";
    dotClass = "bg-[#16a34a]";
    defaultLabel = "Đã duyệt";
  } else if (['rejected', 'cancelled'].includes(norm)) {
    bgClass = "bg-[#fef2f2] text-[#dc2626] border-[#fee2e2]";
    dotClass = "bg-[#dc2626]";
    defaultLabel = "Từ chối";
  } else {
    // pending, screening, waiting, etc.
    bgClass = "bg-[#fff7ed] text-[#ea580c] border-[#ffedd5]";
    dotClass = "bg-[#ea580c] animate-pulse";
    defaultLabel = "Đang chờ duyệt";
  }

  const finalLabel = label || defaultLabel;

  return (
    <span className={cn("inline-flex items-center gap-1.5 px-3 py-1 rounded-full font-bold text-[11px] border whitespace-nowrap select-none", bgClass, className)}>
      {showDot && <span className={cn("w-1.5 h-1.5 rounded-full shrink-0", dotClass)} />}
      <span>{finalLabel}</span>
    </span>
  );
}

export default StatusBadge;
